'use client';

import {
  Slider as BaseSlider,
  SliderProps as BaseSliderProps,
  getClassNames,
} from '@sprd/sprd-component-kit/v2';
import React from 'react';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

export type SliderProps = Omit<BaseSliderProps, 'progressDots' | 'navigation'> & {
  noPadding?: boolean;
  showNavigation?: boolean;
  showProgressDots?: boolean;
};

const Slider: React.FC<SliderProps> = ({
  showNavigation = false,
  showProgressDots = false,
  className,
  noPadding,
  children,
  ...props
}) => {
  const t = useTranslations('slider');

  const classNames = getClassNames(className);
  return (
    <BaseSlider
      {...props}
      navigation={{
        visible: showNavigation,
        nextLabel: t('a11y.nextSlide'),
        prevLabel: t('a11y.previousSlide'),
      }}
      progressDots={{
        visible: showProgressDots,
        labels: {
          navigation: t('a11y.progressDotsLabel'),
          dot: (index: number, total) =>
            t('a11y.dotLabel', { slide: index + 1, totalSlides: total }),
        },
      }}
      className={{
        ...classNames,
        item: clsx(
          classNames.item,
          noPadding
            ? undefined
            : 'last:mr-6 sm:last:mr-6 md:last:mr-8 lg:last:mr-16 xl:last:mr-22.5'
        ),
        slider: clsx(
          classNames.slider,
          noPadding
            ? undefined
            : 'scroll-pl-6 px-4 sm:px-6 md:scroll-pl-8 md:px-8 lg:scroll-pl-16 lg:px-16 xl:scroll-pl-22.5 xl:px-22.5'
        ),
      }}
    >
      {children}
    </BaseSlider>
  );
};

export default Slider;
